<template>
  <div class="section">
    <div class="container" style="margin-top: -30px;">
      
      <b-field>
        <img :src="imageSrc1" alt="" />
      </b-field>
      <b-field class="title24">ເຊີນຮ່ວມ! ງານວາງສະແດງສິນຄ້າກະສິກໍາລາວ 2024,  ຫວັງສົ່ງເສີມຜະລິດຕະພັນກະສິກໍາລາວ ກ້າວສູ່ຕະຫຼາດໂລກເພີ່ມຂຶ້ນ
      </b-field>
      <b-field class="title16-light" style="text-indent: 20px;">
        ກະຊວງ ກະສິກໍາ ແລະ ປ່າໄມ້ ຮ່ວມກັບ ສະມາຄົມທຸລະກິດກະສິກໍາລາວ ແລະ ບັນດາຜູ້ມີສ່ວນຮ່ວມ ຕ່າງໆທັງພາຍໃນ ແລະ ຕ່າງປະເທດ ຈະໄດ້ຈັດງານວາງສະແດງສິນຄ້າກະສິກໍາລາວ 2024 ຫຼື Lao Agri Food Expo 2024 ໃນລະຫວ່າງວັນທີ 16-20 ທັນວາ ທີ່ຈະມາເຖິງນີ້ນັບແຕ່ເວລາ 09:00-20:00 ໂມງ, ທີ່ສູນການຄ້າລາວ-ໄອເຕັກ, ນະຄອນຫຼວງວຽງຈັນ.
      </b-field>
      <b-field>
        <img :src="imageSrc2" alt="" />
      </b-field>

      <b-field class="title16-light" style="text-indent: 20px;">
        ຈຸດປະສົງຂອງງານດັ່ງກ່າວ, ກໍ່ເພື່ອວາງສະແດງ ແລະ ນໍາສະເໜີຜະລິດຕະພັນສິນຄ້າກະສິກໍາຂອງລາວ ທີ່ໂດດເດັ່ນ ແລະ ໄດ້ຮັບຄວາມນິຍົມໄປທົ່ວໂລກ. ນອກນັ້ນ, ຍັງສະແດງນະວັດຕະກໍາ ແລະ ເຕັກໂນ ໂລຊີກະສິກໍາທັນສະໄໝ ເພື່ອນໍາໃຊ້ເຂົ້າໃນການຜະລິດກະສິກໍາ ເຮັດໃຫ້ສາມາດຫຼຸດຜ່ອນຕົ້ນທຶນ ແລະ ມີຜົນຜະລິດທີ່ມີຄຸນະພາບ ແລະ ໄດ້ຕາມມາດຕະຖານການສົ່ງອອກຂອງປະເທດປາຍທາງ, ອັນເຮັດໃຫ້ ການຜະລິດກະສິກໍາຂອງລາວເປັນທີ່ຍອມຮັບຈາກທົ່ວໂລກ ແລະ ມີຄວາມຍືນຍົງໃນອະນາຄົດ.
      </b-field>
      <b-field>
        <img :src="imageSrc3" alt="" />
      </b-field>

      <b-field class="title16-light" style="text-indent: 20px;">
        ສິ່ງສໍາຄັນໄປກວ່ານັ້ນ, ງານດັ່ງກ່າວຍັງເປັນໂອກາດທາງທຸລະກິດ ເປັນຕົ້ນແມ່ນ:
        <ul style="text-indent: 20px;">
        <li>- ການຈັບຄູ່ທຸລະກິດສໍາລັບຜູ້ປະກອບການ ແລະ ນັກລົງທຶນໃນຂະແຫນງກະສິກໍາ ທັງໃນລາວ ແລະ ຕ່າງປະເທດ ເພື່ອຊຸກຍູ້ການຮ່ວມມືໃນພາກພື້ນ ແລະ ສາກົນ</li>
        <li>- ງານວາງສະແດງຜະລິດຕະພັນກະສິກໍາທີ່ມີຄຸນນະພາບ ແລະ ຜະລິດຕະພັນປຸງແຕ່ງຈາກຜູ້ຜະລິດຊັ້ນນໍາ ເຊັ່ນ: ຜະລິດຕະພັນສົດ ແລະ ຜະລິດຕະພັນສໍາເລັດຮູບ, ນະວັດຕະກໍາທີ່ຕອບສະຫນອງຄວາມຕ້ອງການຂອງຕະຫຼາດທີ່ທັນສະໄຫມ</li>
        <li>- ເວທີເສວະນາແບ່ງປັນຄວາມຮູ້: ຮັບຟັງການບັນຍາຍຈາກຜູ້ຊ່ຽວຊານດ້ານກະສິກຳ ແລະ ຜູ້ປະກອບການຈາກທົ່ວປະເທດ ເພື່ອພ້ອມກັນພັດທະນາທ່າແຮງໃນຂົງເຂດກະສິກຳ ແລະ ສະບຽງອາຫານ.</li>

        <li>- ຜົນປະໂຫຍດຂອງການເຂົ້າຮ່ວມກິດຈະກໍາ: ໂອກາດທີ່ຈະຮຽນຮູ້ກ່ຽວກັບການຜະລິດກະສິກໍາແບບທັນສະໄໝ, ການສ້າງເຄືອຂ່າຍທຸລະກິດທັງຢູ່ພາຍໃນ ແລະ ຕ່າງປະເທດ, ແນະນໍາສິນຄ້າ/ການບໍລິການ ທີ່ມີຄຸນນະພາບເໝາະສົມກັບການລົງທຶນໃນຍຸກປັດຈຸບັນ</li>
        <li>- ເພີ່ມທະວີກາລະໂອກາດ: ໃນການຂະຫຍາຍການຕະຫຼາດ ສໍາລັບຜູ້ປະກອບການຂະຫນາດນ້ອຍ ແລະ ຂະໜາດກາງ ເພື່ອພັດທະນາຂະແໜງກະສິກໍາຂອງລາວ ກ້າວສູ່ຕະຫຼາດໂລກໃນອະນາຄົດ</li>
        <li>- Lao Agri Food Expo 2024 ເປີດໂອກາດໃຫ້ທຸກພາກສ່ວນສາມາດເຂົ້າຮ່ວມຟຣີ ແລະ ຂໍເຊີນທຸກທ່ານເຂົ້າມາເປັນສ່ວນໜຶ່ງໃນການຂັບເຄື່ອນກະສິກໍາລາວກ້າວໄປຂ້າງໜ້າ !</li>

        </ul>
      </b-field>
      <b-field>
        <img :src="imageSrc4" alt="" />
      </b-field>
      <b-field class="title16-light">
        ລາຍລະອຽດເພີ່ມເຕີມ ແລະ ຂໍ້ມູນຕິດຕໍ່:<br>
        Facebook: https://www.facebook.com/LaoAgriExpo2024<br>
        Website: www.laoagriexpo.net <br>
        Phone: +85620 23693639 / +85630 9662345<br>
      </b-field>

      

      

      

      
      
     

     
      
    </div>  
  </div>
</template>

<script>
export default {
  name: "home",  
  
  data() {
    return {
      photopath: process.env.NODE_ENV === "production"    
                ? "https://lababiz.com/api/uploads/pages/sponser/"
                : "http://localhost/lababiz/api/uploads/pages/sponser/"
    };
  },
  method: {
    
  },
  mounted() {
   
  },
  computed: {   
    // Using pathify

    imageSrc1() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/page1.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/page1.png';
    },

    imageSrc2() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/page2.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/page2.png';
    },

    imageSrc3() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/page3.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/page3.png';
    },

    imageSrc4() {
      return process.env.NODE_ENV === 'production'
        ? 'https://lababiz.com/api/uploads/pages/news/page4.png'
        : 'http://localhost/lababiz/api/uploads/pages/news/page4.png';
    },
    
    lang() {
     
      return this.$store.get('switchLang') || 1;
    },
  },
};
</script>

<style scoped>
.title24{
  font-size: 24px;
  font-weight: bold;
}

.title24-light{
  font-size: 24px;
}

.title20{
  font-size: 20px;
  font-weight: bold;
}

.title20-light{
  font-size: 20px;
}

.title16{
  font-size: 18px;
  font-weight: bold;
}

.title16-light{
  font-size: 18px;
}

.title14{
  font-size: 16px;
  font-weight: bold;
}
.title14-light{
  font-size: 16px;
  font-weight: bold;
}

.title12{
  font-size: 14px;
  font-weight: bold;
}

.title12-light{
  font-size: 14px;
}

.red16bold{
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.red16{
  color: red;
  font-size: 18px;
  
}

.red14bold{
  color: red;
  font-size: 16px;
  font-weight: bold;
}

.red14{
  color: red;
  font-size: 16px;
}

.red12bold{
  color: red;
  font-size: 14px;
  font-weight: bold;
}

.red12{
  color: red;
  font-size: 14px;
}
</style>
